import type { MaterializedMenuProduct } from '@iheartjane/data-access';

import type {
  JaneSearchState,
  RangeFilterValue,
} from '@jane/search/data-access';

export const selectedFilterRange = (
  searchState: JaneSearchState<MaterializedMenuProduct>,
  filterKey: string
): Partial<RangeFilterValue> => {
  if (filterKey === 'percent_cbd' || filterKey === 'percent_thc') {
    const activeRange = searchState.rangeFilters?.[filterKey];
    return { ...activeRange };
  } else {
    return {};
  }
};
